import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import WebpImage from '../common/WebpImage';

class Header extends Component {
	render() {
		return (
			<React.Fragment>
				<nav className='navbar is-transparent'>
					<div className='container'>
						<div className='navbar-brand'>
							<a className='navbar-item' href='/'>
								<span className='span-logo'>SN</span>
							</a>
						</div>
						<div className='navbar-menu' id='navMenu'>
							<div className='navbar-end'>
								<div className='navbar-item'>
									<p className='control'>
										<a
											className='button is-primary is-outlined is-rounded'
											href='https://slava-nik.github.io/resume'
											target='_blank'
											rel='noreferrer'
										>
											<span>Open CV</span>
										</a>
									</p>
									<p className='control'>
										<AnchorLink
											className='button is-primary is-outlined is-rounded contact-link'
											href='#contacts'
										>
											<span>Contact me</span>
										</AnchorLink>
									</p>
								</div>
							</div>
						</div>
					</div>
				</nav>
				<section className='hero is-white has-text-centered'>
					<div className='hero-body'>
						<div className='container'>
							<div className='columns is-centered'>
								<div className='column'>
									<h1 className='title is-spaced is-size-1-desktop is-size-2-tablet is-size-3-mobile'>
										Front-end &amp; Back-end developer
									</h1>
									<h2 className='subtitle is-size-4-desktop'>
										I develop awesome web applications and I love what I do.
									</h2>
									<WebpImage
										className='avatar'
										backupImage='media/author.jpg'
										backupFormat='jpg'
										webpImage='media/author.webp'
										alt='Slava Nikolaevich'
									/>
								</div>
							</div>
						</div>
					</div>
					<div className='hero-foot'>
						<div className='container'>
							<img
								style={{ minHeight: '110px' }}
								className='is-bottom'
								src='./media/hero.svg'
								alt="developer's workplace"
							/>
						</div>
					</div>
				</section>
			</React.Fragment>
		);
	}
}

export default Header;
